// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.history-project-dialog[data-v-3d43a32f] {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/views/DesignBudgetSoftware/InitialSchemeEstimate/HistoryProjectDialog.vue","webpack://./HistoryProjectDialog.vue"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;ACAF","sourcesContent":["\n.history-project-dialog {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  ::v-deep .match-project {\n    // height: 250px;\n  }\n}\n",".history-project-dialog {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
